import React, { Component } from 'react';
import { Digital, Dots } from 'react-activity';
import { Spin, Icon } from 'antd';

export const Indicator = ({type}) => (
    <div style={{position: 'absolute', left: '50%', top: '50%',transform: 'translate(-50%, -50%)'}}>
        {type==='digital'?(<Digital color="#597EF7" />):(<Dots color="#597EF7" />)};
    </div>
);

export const Spinner = ({type}) => (
    <div style={{position: 'absolute', left: '50%', top: '50%',transform: 'translate(-50%, -50%)'}}>
        {type==='loading'?<Spin indicator={<Icon type="loading" />} />:<Spin />}
    </div>
);

export default class SpinnerWrap extends Component {
    

    render() {
        const { loading } = this.props;

        return (
            <div style={{position:'relative'}}>
                { loading && (
                <div
                    style={{
                    display: 'block',
                    position: 'absolute',
                    zIndex: 657,
                    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                    margin: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                    }}>
                    <Spinner type="loading" />
                </div>
                )}
                {this.props.children}
            </div>
        )
    }
}
